export enum CustomersStatuses {
  true = 'Active',
  false = 'Archived',
}

export default CustomersStatuses;
